<script lang="ts">
	// Components
	import WizardWrapperEditableObject from 'src/components/ModalWizzard/WizardWrapperEditableObject.svelte';
	import SelectSensor from './WizardSteps/SelectSensor.svelte';
	import ThermostatMode from './WizardSteps/ThermostatMode.svelte';
	import SelectActuator from './WizardSteps/SelectActuator.svelte';
	// Helpers
	import { _deepClone, capFirstChar, deepCopy } from 'src/helpers/utilities';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	// Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	// Svelte hooks
	import { beforeUpdate, createEventDispatcher } from 'svelte';

	export let showModal, editableObject;

	const cacheThermostat = deepCopy(editableObject.thermostat);
	const dispatcher = createEventDispatcher();

	$: wizardItems = [
		{
			active: editableObject.activeIndex === 0,
			activeIndex: 0,
			disabled: false,
			showMoreDots: false,
			stepNumber: 1,
			title: capFirstChar($format('main_step', { default: 'main' })),
			tooltipTitle: '',
			component: ThermostatMode,
			validation: false,
		},
		{
			active: editableObject.activeIndex === 1,
			activeIndex: 1,
			disabled: false,
			showMoreDots: false,
			stepNumber: 2,
			title: capFirstChar($format('sensor_step', { default: 'sensor' })),
			tooltipTitle: '',
			component: SelectSensor,
			validation: !Array.isArray(editableObject.selectedDevices),
		},
		{
			active: editableObject.activeIndex === 2,
			activeIndex: 2,
			disabled: false,
			showMoreDots: false,
			stepNumber: 3,
			title: capFirstChar($format('type_actuator', { default: 'actuator' })),
			tooltipTitle: '',
			component: SelectActuator,
			validation: !Array.isArray(editableObject.selectedDevices),
		},
		// {// TODO finish schedules
		// 	active: editableObject.activeIndex === 3,
		// 	activeIndex: 3,
		// 	disabled: false,
		// 	showMoreDots: false,
		// 	stepNumber: 4,
		// 	title: capFirstChar($format('schedules_step', { default: 'schedules' })),
		// 	tooltipTitle: '',
		// 	component: ThermostatSchedules,
		// 	validation: !Array.isArray(editableObject.selectedDevices)
		// }
	];

	let validation = {
		0: {
			disabled: false,
		},
		1: {
			disabled:
				Array.isArray(editableObject.selectedDevices) &&
				typeof editableObject.selectedDevices === 'undefined',
		},
		2: {
			disabled:
				Array.isArray(editableObject.selectedDevices) &&
				typeof editableObject.selectedDevices === 'undefined',
		},
	};
	beforeUpdate(() => {
		const _items = wizardItems;
		// if (editableObject.category === 'schedules') {
		// 	_items.splice(1, 1, {
		// 		active: editableObject.activeIndex === 1,
		// 		activeIndex: 1,
		// 		disabled: false,
		// 		showMoreDots: false,
		// 		stepNumber: 2,
		// 		title: $format('schedules_step'),
		// 		tooltipTitle: '',
		// 		component: ThermostatSchedules,
		// 		validation: false
		// 	});
		// } else {
		// 	_items[1].component = SelectSensor;
		// }
		// _items.forEach((item, index) => {
		// 	validation[index].disabled = _items?.[index]?.validation;
		// 	item.disabled = validation?.[item.activeIndex]?.disabled;

		// 	lockButton = validation?.[item.activeIndex]?.disabled;
		// });

		// wizardItems = _items;
	});

	const saveDevice = async () => {
		if (
			editableObject.thermostat.type !== cacheThermostat.type ||
			editableObject.thermostat.actuator !== cacheThermostat.actuator ||
			editableObject.thermostat.sensor !== cacheThermostat.sensor
		) {
			const res = await gen2Request(editableObject.device, 'Thermostat.SetConfig', {
				id: editableObject.thermostat.id,
				config: { ...editableObject.thermostat },
			});
			onSettingsResponse(res, editableObject.device);
			if (res.isok) {
				dispatcher('save', { thermostat: editableObject.thermostat });
				cacheThermostat.type = editableObject.thermostat.type;
				cacheThermostat.actuator = editableObject.thermostat.actuator;
				cacheThermostat.sensor = editableObject.thermostat.sensor;
			}
		}
	};
	const closeModal = () => {
		showModal = false;
	};
</script>

<!-- DO NOT REMOVE COMMENT: Padding references -->
<WizardWrapperEditableObject
	bind:showModal
	on:close={closeModal}
	title={capFirstChar(
		$format('title_edit_thermostat', {
			default: 'Edit thermostat',
		}),
	)}
	wizardContentClasses="pl-0 pr-0"
	bind:wizardItems
	bind:editableObject
	bind:validation
	callback={saveDevice}
/>
